import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Typography } from './Typography';
import { colors } from '../utils';

const getColor = props => {
  if (props.customer) {
    return colors.w01;
  }

  return colors.g01;
};

const getTextColor = props => {
  if (props.customer) {
    return colors.g04;
  }

  return colors.g05;
};

const getFontSize = props => {
  if (props.customer) {
    return 12;
  }

  return 16;
};

const getMargin = props => {
  if (props.customer) {
    return -16;
  }

  return 40;
};

const Wrapper = styled.div`
  background: ${getColor};
  border-radius: 4px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  margin: 10px 0;
  margin-left: ${getMargin}px;
  padding: 6px 13px;

  &:first-child {
    margin-top: 0;
  }
`;

const User = styled.h3`
  color: ${getTextColor};
  font-size: ${getFontSize}px;
  font-weight: bold;
  margin: 0;
  text-align: left;
`;

const Text = styled(Typography)`
  color: ${getTextColor};
  font-size: 16px;
  margin: 4px 0;
  text-align: left;
`;

const Script = props => {
  const { children, user } = props;

  return (
    <Wrapper {...props}>
      <User {...props}>{user}</User>

      <Text {...props}>{children}</Text>
    </Wrapper>
  );
};

Script.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired,
  user: PropTypes.string.isRequired
};

export { Script };
